/**
 * Component NaviMobileOffCanvasToggler
 *
 * 
 * @type {String}
 */

export class NaviMobileOffCanvasToggler {
    constructor(triggername, togglclass) {
        this.triggers = document.querySelector(triggername);
        this.togglclass = togglclass;
        this.listeners();
    }
    listeners() {
        if (this.triggers) {
            this.triggers.addEventListener('click', () => this.toggleNavi());
        }
        window.addEventListener('keydown', event => {
            let key = event.keyCode;
            if (key === 27) {
                this.closeNavi();
            }
        });
    }
    toggleNavi() {
        this.toggList = document.querySelectorAll(this.togglclass);
        this.toggList.forEach(sel => {
            if (sel.classList.contains("-state--active") || sel.classList.contains("-state--off")) {
                sel.classList.toggle("-state--off");
            }
            sel.classList.toggle("-state--active");
        });
        // console.log(this.togglclass + ' kreischt.');
    }
    closeNavi() {
        let togglesList = document.querySelectorAll(this.togglclass);
        togglesList.forEach(sel => {
            sel.classList.remove("-state--active");
        });
        document.body.classList.remove('c-modal__backdrop');
    }
}

new NaviMobileOffCanvasToggler("#js-naviMobile__trigger", ".js-naviMobile__toggle");